const parseLocale = (defaultLocale: string, locale?: string): string[] =>
  locale ? locale.split('-') : defaultLocale.split('-');

export default parseLocale;
